;(function(){'use strict';

module.exports = {
  props: {
    slidesQuerySelector: { type: String, require: true },
    thumbnailsQuerySelector: { type: String, require: true },
    autoPlay: { type: String, default: "0" }
  },
  data: function data() {
    return {
      selectedIndex: 0,
      slidesCount: this.slidesQuerySelector && document.querySelectorAll(this.slidesQuerySelector).length,
      autoPlayInterval: null
    };
  },

  watch: {
    selectedIndex: function selectedIndex() {
      this.updateCarousel();
    }
  },
  methods: {
    init: function init() {
      this.enableAutoPlay();
      this.enableThumbnailsClick();
    },
    enableAutoPlay: function enableAutoPlay() {
      var _this = this;

      if (parseInt(this.autoPlay)) {
        this.autoPlayInterval = setInterval(function () {
          if (_this.selectedIndex >= _this.slidesCount - 1) {
            _this.selectedIndex = 0;
          } else {
            _this.selectedIndex += 1;
          }
        }, this.autoPlay);
      }
    },
    enableThumbnailsClick: function enableThumbnailsClick() {
      var wrapper = document.querySelectorAll(this.thumbnailsQuerySelector);
      if (wrapper && wrapper.length) {
        wrapper[0].parentElement.addEventListener('click', this.handleThumbnailClick);
      }
    },
    handleThumbnailClick: function handleThumbnailClick(event) {
      var slideIndex = event.target.dataset.index || event.target.parentElement.dataset.index;
      if (slideIndex && slideIndex !== this.selectedIndex) {
        this.selectedIndex = parseInt(slideIndex);
        if (this.autoPlayInterval) {
          clearInterval(this.autoPlayInterval);
        }
      }
    },
    updateCarousel: function updateCarousel() {
      var _this2 = this;

      var querySelectors = [this.slidesQuerySelector, this.thumbnailsQuerySelector];
      querySelectors.forEach(function (querySelector) {
        _this2.deactivateElements(querySelector);
        _this2.activateElement(querySelector);
      });
    },
    deactivateElements: function deactivateElements(querySelector) {
      var elements = document.querySelectorAll(querySelector);
      if (elements && elements.length) {
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove('active');
        }
      }
    },
    activateElement: function activateElement(querySelector) {
      var elements = document.querySelectorAll(querySelector);
      if (elements && elements[this.selectedIndex]) {
        elements[this.selectedIndex].classList.add('active');
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
};})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',[_t("default")],2)}}
__vue__options__.staticRenderFns = []
